import { render, staticRenderFns } from "./HistoryCustomerAdding.vue?vue&type=template&id=244cc1f9&scoped=true&"
import script from "./HistoryCustomerAdding.vue?vue&type=script&lang=js&"
export * from "./HistoryCustomerAdding.vue?vue&type=script&lang=js&"
import style0 from "./HistoryCustomerAdding.vue?vue&type=style&index=0&id=244cc1f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244cc1f9",
  null
  
)

export default component.exports